export const isPhone = function () {
  let userAgent = navigator.userAgent;
  const mobile = {
    Android: () => !!userAgent.match(/Android/i),
    BlackBerry: () => !!userAgent.match(/BlackBerry/i),
    IOS: () => !!userAgent.match(/iPhone|iPad|iPod/i),
    WindowsPhone: () => !!userAgent.match(/IEMobile/i),
  };
  return mobile.Android() || mobile.BlackBerry() || mobile.IOS() || mobile.WindowsPhone();
};

/**
 * 去抖函数
 * @param timeout: type=number
 * @description 去抖函数，timeout是设置去抖的间隔，会在去抖之后执行最后一次的事件
 * */
export function debounce(timeout=300) {
  let timeoutSet = null;
  let callbackMakeup = null;
  let argsMakeup = null
  return function (callback, ...args) {
    if (!timeoutSet) {
      callback(args);
      callbackMakeup = null;
      argsMakeup = null;

      timeoutSet = setTimeout(() => {
        timeoutSet = null;
        if (callbackMakeup && false) callbackMakeup(argsMakeup);

        callbackMakeup = null;
        argsMakeup = null;
      }, timeout)
    } else {
      callbackMakeup = callback;
      argsMakeup = args;
    }
  }
}